import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "LEARN_REACHFINAL",
  title: defineMessage({
    id: "fig.learning.LEARN_REACHFINAL.title",
    defaultMessage: `Learning by expected school completion`,
  }),
  caption: defineMessage({
    id: "fig.learning.LEARN_REACHFINAL.caption",
    defaultMessage: `Most children who do not learn do so despite completing school.`,
  }),
  source: defineMessage({
    id: "fig.learning.LEARN_REACHFINAL.source",
    defaultMessage: `UIS database`,
  }),
};
